import React from "react";
import { Box, Typography } from "@mui/material";
import PostAddIcon from '@mui/icons-material/PostAdd';

const NewFastEntryInvoice = ({ onAdd }) => {
  return (
    <Box
      onClick={onAdd}
      sx={{
        width: "100%",
        backgroundColor: "#f5f5f5",
        p: 2,
        my: "2rem",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "#eeeeee"
        },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        border: "1px dashed rgba(0, 0, 0, 0.12)",
        borderRadius: "2px"
      }}
    >
      <PostAddIcon sx={{ color: "#666666", fontSize: "1.5rem" }} />
      <Typography
        sx={{
          color: "#666666",
          fontSize: "0.875rem"
        }}
      >
        New Invoice
      </Typography>
    </Box>
  );
};

export default NewFastEntryInvoice;